/**
 * 运营属性变更
 * 
 */

const operationalChange = {
  // 申请
  getOperationalAttrChangeApply: {
    url: '/fortune/ContractOperationalAttrChange/Apply',
    method: 'post'
  },
  // 列表
  getOperationalAttrChangeList: {
    url: '/fortune/ContractOperationalAttrChange/GetList',
    method: 'get'
  },
  // 驳回重提编辑
  getOperationalAttrChangeReApply: {
    url: '/fortune/ContractOperationalAttrChange/ReApply',
    method: 'post'
  },
  // 删除
  getOperationalDelWithAudit: {
    url: '/fortune/ContractOperationalAttrChange/delWithAudit',
    method: 'post'
  },
  // 详情
  getOperationalAttrChangeDetail: {
    url: '/fortune/ContractOperationalAttrChange/GetDetail',
    method: 'get'
  },
  // 审批
  getOperationalAttrChangeAuditl: {
    url: '/fortune/ContractOperationalAttrChange/Audit',
    method: 'post'
  },
  // 导出
  getOperationalAttrChangeExportTpl: {
    url: '/fortune/ContractOperationalAttrChange/GetExportTpls',
    method: 'get'
  },
  getOperationalAttrChangeTplItems: {
    url: '/fortune/ContractOperationalAttrChange/GetExportFields',
    method: 'get'
  },
  getOperationalAttrChangeSaveExportTpls: {
    url: '/fortune/ContractOperationalAttrChange/SaveExportTpls',
    method: 'post'
  },
  getOperationalAttrChangeExport: {
    url: '/fortune/ContractOperationalAttrChange/Export',
    method: 'post'
  },
  // 合同模板修改列表
  getEditContractTmpList: {
    url: '/fortune/contractTmpChange/getList',
    method: 'get'
  },
  // 合同模板修改导入
  importContractTmp: {
    url: '/fortune/contractTmpChange/importContractTmp',
    method: 'post'
  },
  // 运营属性变更导入列表
  getImportOperationalAttrList: {
    url: '/fortune/VendorContractOperationalAttributes/GetUploadRecord',
    method: 'get'
  },
  // 运营属性变更导入
  importOperationalAttr: {
    url: '/fortune/VendorContractOperationalAttributes/upload',
    method: 'post'
  },
}
export default operationalChange